import { useRef } from 'react';
export default function useOnChange(value, onChange) {
  var previousValueRef = useRef(value);
  var previousValue = previousValueRef.current;
  previousValueRef.current = value;

  if (value !== previousValue) {
    onChange(value, previousValue);
  }
}
//# sourceMappingURL=useOnChange.js.map